import * as React from 'react';
import { Box, Typography, Select, MenuItem } from '@mui/material';
import BusinessIcon from '@mui/icons-material/Business';
import { useUserStore } from 'store';
import { useTranslation } from 'react-i18next';


import { getRoleLabel } from '../../utils/roles';
function OrganizationSelector() {
  const { user, currentOrganization, switchOrganization } = useUserStore();
  const { t } = useTranslation();

  const organizations = user?.organizations || [];

  // Don't show selector if user has only one organization
  if (organizations.length <= 1) {
    return null;
  }

  const handleChange = (event) => {
    const orgId = event.target.value;
    const org = organizations.find((o) => o.organization_id === orgId);
    if (org) {
      // Store action: persists the choice and hard-navigates to "/" (see store.js).
      switchOrganization(org);
    }
  };

  return (
    <Box
      sx={{
        px: 2,
        py: 1.5,
        borderBottom: '1px solid rgba(255,255,255,0.1)',
      }}
    >
      <Typography
        sx={{
          fontSize: '10px',
          fontWeight: 600,
          color: 'rgba(255,255,255,0.5)',
          textTransform: 'uppercase',
          letterSpacing: '0.5px',
          mb: 0.75,
        }}
      >
        {t("Organization")}
      </Typography>
      <Select
        value={currentOrganization?.organization_id || ''}
        onChange={handleChange}
        size="small"
        fullWidth
        displayEmpty
        sx={{
          bgcolor: 'rgba(255,255,255,0.1)',
          color: 'white',
          borderRadius: '8px',
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: 'rgba(255,255,255,0.2)',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: 'rgba(255,255,255,0.3)',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: 'rgba(255,255,255,0.4)',
          },
          '& .MuiSelect-icon': {
            color: 'rgba(255,255,255,0.7)',
          },
          '& .MuiSelect-select': {
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            py: 1,
            // Keep the chevron's lane free: a long workshop name is cut with an ellipsis
            pr: '32px !important',
            minWidth: 0,
          },
        }}
        renderValue={(selected) => {
          const org = organizations.find((o) => o.organization_id === selected);
          return (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0 }}>
              <BusinessIcon sx={{ fontSize: 18, opacity: 0.8, flexShrink: 0 }} />
              <Typography noWrap sx={{ fontSize: '13px', fontWeight: 500 }}>
                {org?.organization_name || t("Select organization")}
              </Typography>
            </Box>
          );
        }}
      >
        {organizations.map((org) => (
          <MenuItem key={org.organization_id} value={org.organization_id}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <BusinessIcon sx={{ fontSize: 18, color: 'text.secondary' }} />
              <Box>
                <Typography sx={{ fontSize: '13px', fontWeight: 500 }}>
                  {org.organization_name}
                </Typography>
                <Typography sx={{ fontSize: '11px', color: 'text.secondary' }}>
                  {getRoleLabel(org.role, t)}
                </Typography>
              </Box>
            </Box>
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
}

export default OrganizationSelector;
